module.exports = __webpack_public_path__ + "img/xGrey.9a5f7e36.svg";